export { autoPause } from './autoPause.js';
export { ease } from './ease/index.js';
export { lerp } from './lerp.js';
export { scrollAnimation } from './scrollAnimation.js';
export { vecToHSL, vecToRGB } from './vecToColor.js';
